import * as React from 'react';
import Slide from '@mui/material/Slide';
const ModalTransitionComponent = React.forwardRef((props, ref) => (React.createElement(Slide, Object.assign({ ref: ref }, props, { direction: "up", children: props.children }))));
export default ModalTransitionComponent;
